module.exports = __webpack_public_path__ + "img/safe_camical_03.bf99e97f.jpg";